// src/main.js
import './assets/tailwind.css';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import './registerServiceWorker';

const app = createApp(App);

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate); 

app.use(pinia);  
app.use(router);

// Tema escuro
const darkMode = localStorage.getItem('darkMode') === 'true';
if (darkMode) {
  document.documentElement.classList.add('dark');
} else {
  document.documentElement.classList.remove('dark');
}
app.provide('isDark', darkMode);

// Inicializa o store da clínica para aplicar estilos do localStorage
import { useClinicStore } from './stores/settings/clinicStore';
const clinicStore = useClinicStore(pinia);
clinicStore.initialize();

app.mount('#app'); // ✅ apenas um mount

// Service Worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js');
}
